import { createClient } from "./utils";
import { ARBITRUM, ARBITRUM_TESTNET, AVALANCHE, ETH_MAINNET, ZKEVM } from "config/chains";

export const chainlinkClient = createClient(ETH_MAINNET, "chainLink");

export const arbitrumGraphClient = createClient(ARBITRUM, "stats");
export const arbitrumReferralsGraphClient = createClient(ARBITRUM, "referrals");
//export const nissohGraphClient = createClient(ARBITRUM, "nissohVault");
export const zkevmGraphClient = createClient(ZKEVM, "stats");
export const nissohGraphClient = createClient(ZKEVM, "nissohVault");

export const avalancheGraphClient = createClient(AVALANCHE, "stats");
export const avalancheReferralsGraphClient = createClient(AVALANCHE, "referrals");

export function getGmxGraphClient(chainId: number) {
  if (chainId === ARBITRUM) {
    return arbitrumGraphClient;
  } else if (chainId === AVALANCHE) {
    return avalancheGraphClient;
  } else if (chainId === ARBITRUM_TESTNET) {
    return null;
  } else if (chainId === ZKEVM) {
    return zkevmGraphClient;
  }

  throw new Error(`Unsupported chain ${chainId}`);
}
